import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const testimonials = [
  {
    name: "Candice Wu",
    avatar:
      "https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50cc7f6d7fe4bb93b0f67_Avatar%20Image%201.png",
    review:
      "Zola has completely transformed how we collect and manage customer feedback. Our Google and Yelp reviews have increased significantly, and the automated surveys help us track customer satisfaction effortlessly. Highly recommended!",
  },
  {
    name: "Mollie Hall",
    avatar:
      "https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50cc7f6d7fe4bb93b0f64_Avatar%20Image%202.png",
    review:
      "The best platform for managing customer reviews and surveys! The NPS and CSAT tracking give us deep insights into our customer experience, and the employee performance tracking feature is a game-changer.",
  },
  {
    name: "Olivia Rhye",
    avatar:
      "https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50cc7f6d7fe4bb93b0f6a_avatar-35.jpg",
    review:
      "Zola is a must-have for businesses looking to improve their online presence. The surveys and review requests have made a huge difference in our customer engagement and retention.",
  },
  {
    name: "Koray Okumus",
    avatar:
      "https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50cc7f6d7fe4bb93b0f5e_Avatar%20Image%203.png",
    review:
      "Great tool for reputation management. The ability to automate review requests across multiple platforms has been super helpful for our business!",
  },
  {
    name: "Olivia Rhye",
    avatar:
      "https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50cc7f6d7fe4bb93b0f6a_avatar-35.jpg",
    review:
      "Zola is a must-have for businesses looking to improve their online presence. The surveys and review requests have made a huge difference in our customer engagement and retention.",
  },
  {
    name: "Kelly Williams",
    avatar:
      "https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50cc7f6d7fe4bb93b0f61_Avatar%20Image%204.png",
    review:
      "Before using Zola, we struggled with getting customer feedback. Now, we get consistent reviews, and the insights help us improve our services. 10/10!",
  },
];

const TestimonialsSection = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  return (
    <section className="w-full bg-white py-20" ref={ref}>
      <div className="max-w-7xl mx-auto px-6 text-center">
        {/* Heading */}
        <motion.h2
          initial={{ y: -30, opacity: 0 }}
          animate={inView ? { y: 0, opacity: 1 } : {}}
          transition={{ duration: 0.6 }}
          className="text-3xl md:text-5xl font-semibold text-gray-900 mb-4"
        >
          Don’t just take our word for it
        </motion.h2>
        <motion.p
          initial={{ y: -20, opacity: 0 }}
          animate={inView ? { y: 0, opacity: 1 } : {}}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="text-gray-600 text-lg mb-12"
        >
          Hear from some of our amazing customers who are building faster.
        </motion.p>

        {/* Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ y: 40, opacity: 0 }}
              animate={inView ? { y: 0, opacity: 1 } : {}}
              transition={{
                duration: 0.6,
                delay: 0.3 + index * 0.1,
                ease: "easeOut",
              }}
              className="bg-[#f9fafb] p-8 rounded-2xl text-left flex flex-col justify-between shadow-sm hover:shadow-md transition duration-300"
            >
              {/* Stars */}
              <div className="flex mb-4">
                {Array(5)
                  .fill(0)
                  .map((_, idx) => (
                    <svg
                      key={idx}
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                      className="h-5 w-5 text-yellow-400"
                    >
                      <path d="M12 .587l3.668 7.431L24 9.748l-6 5.849L19.336 24 12 20.201 4.664 24 6 15.597 0 9.748l8.332-1.73z" />
                    </svg>
                  ))}
              </div>

              {/* Review */}
              <p className="text-[#7f56d9] text-base mb-6">
                "{testimonial.review}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-4">
                <img
                  src={testimonial.avatar}
                  alt={testimonial.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <p className="font-semibold text-gray-900">
                    {testimonial.name}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
